<template>
  <div class="grid grid-cols-2 gap-5">
    <!-- Left Column -->

    <div class="space-y-2">
      <div
        class="flex gap-1 justify-end"
        v-if="
          ifCurrentMode === 'edit' && formData.paymentstatus !== 'Completed'
        "
      >
        <button
          @click="isImportApproval = true"
          class="px-4 py-2.5 bg-blue-100 text-blue-700 text-xs font-medium rounded-md shadow-sm hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-300 transition"
        >
          Import Approval Number
        </button>
        <IntegrateMAMs
          :modalTrigger="isImportApproval"
          :modalDetails="formData"
          @close="isImportApproval = false"
          @passData="getDataFromMAMS"
        />
      </div>
      <div class="flex gap-1 flex-col">
        <label class="block text-xs text-gray-700"
          >Company <span class="text-red-600">*</span></label
        >

        <input
          @input="filterCompanies"
          :disabled="formData.paymentstatus"
          v-model="formData.company"
          type="text"
          :class="[
            'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
            errors.company && !formData.company
              ? 'border-red-500'
              : 'border-gray-300',
          ]"
          placeholder="Name of Agency"
        />

        <div class="relative">
          <ul
            v-if="showSuggestionsCompany && filteredCompanies.length"
            class="absolute bg-white border border-gray-300 rounded shadow-lg z-[1000] left-0 max-h-56 w-full overflow-y-auto"
          >
            <li
              v-for="(item, index) in filteredCompanies"
              :key="index"
              @click="selectCompany(item.Companies)"
              class="px-4 py-2 text-xs cursor-pointer hover:bg-blue-100"
            >
              {{ item.Companies }}
            </li>
          </ul>
        </div>
      </div>

      <div class="flex gap-1 flex-col">
        <label class="block text-xs text-gray-700"
          >Contact Person<span class="text-red-600">*</span></label
        >
        <input
          v-model="formData.contactperson"
          :disabled="formData.paymentstatus"
          type="text"
          :class="[
            'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
            errors.contactperson && !formData.contactperson
              ? 'border-red-500'
              : 'border-gray-300',
          ]"
          placeholder="Name of Agent / Contact Person"
        />
      </div>
      <div class="flex gap-1 flex-col">
        <label class="block text-xs text-gray-700"
          >Member Name<span class="text-red-600">*</span></label
        >
        <input
          v-model="formData.membername"
          :disabled="formData.paymentstatus"
          type="text"
          :class="[
            'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
            errors.membername && !formData.membername
              ? 'border-red-500'
              : 'border-gray-300',
          ]"
          placeholder="Eg. Dela Cruz, Juan"
        />
      </div>
      <div class="flex gap-1 flex-col">
        <label class="block text-xs text-gray-700"
          >Provider Name<span class="text-red-600">*</span></label
        >
        <input
          :disabled="formData.paymentstatus"
          v-model="providername"
          @input="filterSuggestions"
          type="text"
          :class="[
            'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
            errors.providername && !formData.providername
              ? 'border-red-500'
              : 'border-gray-300',
          ]"
          placeholder="Enter Provider Name"
        />
        <div class="relative">
          <ul
            v-if="showSuggestions && itemProviders.length"
            class="absolute bg-white border border-gray-300 rounded shadow-lg z-[1000] left-0 max-h-36 w-full overflow-y-auto"
          >
            <li
              v-for="(provider, index) in itemProviders"
              :key="index"
              @click="selectProvider(provider.ProviderName)"
              class="px-4 py-2 text-xs cursor-pointer hover:bg-blue-100"
            >
              {{ provider.ProviderName }}
            </li>
          </ul>
        </div>
      </div>
      <div class="flex gap-1 flex-col">
        <label class="block text-xs text-gray-700"
          >Type of Availment<span class="text-red-600">*</span></label
        >
        <select
          @change="formData.transtype = null"
          :disabled="formData.paymentstatus"
          :class="[
            'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
            errors.availmenttype && !formData.availmenttype
              ? 'border-red-500'
              : 'border-gray-300',
          ]"
          v-model="formData.availmenttype"
        >
          <option disabled value="">--Please select--</option>
          <option
            v-for="(item, index) in availmentItems"
            :key="index"
            :value="item"
          >
            {{ item }}
          </option>
        </select>
      </div>
      <div
        class="flex gap-1 flex-col"
        v-if="formData.availmenttype === 'Out-Patient'"
      >
        <label class="block text-xs text-gray-700"
          >Type of Transaction <span class="text-red-600">*</span></label
        >
        <select
          :class="[
            'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
            errors.transtype && !formData.transtype
              ? 'border-red-500'
              : 'border-gray-300',
          ]"
          v-model="formData.transtype"
          :disabled="formData.paymentstatus"
        >
          <option disabled value="">--Please select--</option>
          <option
            v-for="(item, index) in transactionItems"
            :key="index"
            :value="item"
          >
            {{ item }}
          </option>
        </select>
      </div>
      <!-- Provider Auto Suggest -->

      <div class="flex gap-1 flex-col">
        <label class="block text-xs text-gray-700"
          >Date of Admission<span class="text-red-600">*</span></label
        >
        <input
          :max="currentDate"
          :disabled="formData.paymentstatus"
          v-model="formData.admitdate"
          type="date"
          :class="[
            'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
            errors.admitdate && !formData.admitdate
              ? 'border-red-500'
              : 'border-gray-300',
          ]"
        />
      </div>
      <div
        class="flex gap-1 flex-col"
        v-if="formData.availmenttype === 'In-Patient'"
      >
        <label class="block text-xs text-gray-700"
          >Date of Discharged<span class="text-red-600">*</span></label
        >
        <input
          :max="currentDate"
          :disabled="formData.paymentstatus"
          v-model="formData.dischargedate"
          type="date"
          :class="[
            'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
            errors.dischargedate && !formData.dischargedate
              ? 'border-red-500'
              : 'border-gray-300',
          ]"
        />
      </div>
    </div>

    <!-- Right Column -->
    <div class="space-y-2">
      <div class="flex gap-1 flex-col">
        <label class="block text-xs text-gray-700">
          {{
            formData.availmenttype === "In-Patient"
              ? "Final Diagnosis"
              : formData.transtype === "Laboratory"
              ? "Diagnosis"
              : formData.transtype === "Consultation"
              ? "Chief Complaint"
              : "Diagnosis"
          }}<span class="text-red-600">*</span>
        </label>
        <textarea
          :disabled="formData.paymentstatus"
          v-model="formData.symptoms"
          rows="3"
          :class="[
            'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
            errors.symptoms && !formData.symptoms
              ? 'border-red-500'
              : 'border-gray-300',
          ]"
        />
      </div>
      <div class="flex gap-1 flex-col">
        <label class="block text-xs text-gray-700"
          >Status<span class="text-red-600">*</span></label
        >
        <select
          :disabled="formData.paymentstatus"
          @change="
            (formData.renderstartdate = null),
              (formData.graceperiod =
                formData.approvaltype === 'Pending Documents' ? 30 : 0)
          "
          :class="[
            'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
            errors.approvaltype && !formData.approvaltype
              ? 'border-red-500'
              : 'border-gray-300',
          ]"
          v-model="formData.approvaltype"
        >
          <option disabled value="">--Please select--</option>
          <option
            v-for="(item, index) in approvaltypeItems"
            :key="index"
            :value="item"
          >
            {{ item }}
          </option>
        </select>
      </div>

      <div
        class="flex gap-1 flex-col"
        v-if="formData.approvaltype === 'Pending Documents'"
      >
        <label class="block text-xs text-gray-700"
          >First Notification Date<span class="text-red-600">*</span></label
        >
        <div class="flex gap-3">
          <input
            :disabled="formData.paymentstatus"
            v-model="formData.renderstartdate"
            type="date"
            :class="[
              'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
              errors.renderstartdate && !formData.renderstartdate
                ? 'border-red-500'
                : 'border-gray-300',
            ]"
          />
          <input
            :disabled="formData.paymentstatus"
            v-model="formData.graceperiod"
            class="border shadow-elegant rounded-md px-4 py-2.5 text-xs w-20"
            type="number"
          />
        </div>
      </div>
      <div class="flex gap-1 flex-col">
        <label class="block text-xs text-gray-700"
          >Date Received <span class="text-red-600">*</span></label
        >
        <input
          :max="currentDate"
          :disabled="formData.paymentstatus"
          v-model="formData.requestdate"
          type="date"
          :class="[
            'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
            errors.requestdate && !formData.requestdate
              ? 'border-red-500'
              : 'border-gray-300',
          ]"
        />
      </div>
      <div
        class="flex gap-1 flex-col"
        v-if="formData.approvaltype === 'Declined'"
      >
        <label class="block text-xs text-gray-700"
          >Date Entry <span class="text-red-600">*</span></label
        >
        <input
          :max="currentDate"
          :disabled="formData.paymentstatus"
          v-model="formData.declineddate"
          type="date"
          :class="[
            'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
            errors.declineddate && !formData.declineddate
              ? 'border-red-500'
              : 'border-gray-300',
          ]"
        />
      </div>
      <div
        class="flex gap-1 flex-col"
        v-if="formData.approvaltype === 'Declined'"
      >
        <label class="block text-xs text-gray-700"
          >Reason<span class="text-red-600">*</span></label
        >
        <select
          :class="[
            'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
            errors.declinedreason && !formData.declinedreason
              ? 'border-red-500'
              : 'border-gray-300',
          ]"
          v-model="formData.declinedreason"
        >
          <option disabled value="">--Please select--</option>
          <option
            v-for="(item, index) in declinedItems"
            :key="index"
            :value="item"
          >
            {{ item }}
          </option>
        </select>
      </div>

      <div class="flex gap-1 flex-col" v-if="false">
        <label class="block text-xs text-gray-700">Description</label>
        <textarea
          v-model="formData.reasondothers"
          rows="2"
          class="w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs"
        />
      </div>
      <div class="flex gap-1 flex-col">
        <label
          v-if="formData.approvaltype === 'Declined'"
          class="block text-xs text-gray-700"
          >Letter for Declined Remarks
          <span class="text-red-600">*</span></label
        >
        <label v-else class="block text-xs text-gray-700">Remarks</label>
        <textarea
          v-if="formData.approvaltype === 'Declined'"
          :disabled="formData.paymentstatus"
          placeholder="Please provide a clear reason for declining. This remark will be part of the composition of the official decline letter."
          v-model="formData.declinedremarks"
          rows="8"
          :class="[
            'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
            errors.declinedremarks && !formData.declinedremarks
              ? 'border-red-500'
              : 'border-gray-300',
          ]"
        />

        <textarea
          v-else
          :disabled="formData.paymentstatus"
          v-model="formData.remarks"
          rows="4"
          class="w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs"
        />
      </div>
      <div class="py-3" v-if="formData.paymentstatus ? true : false">
        <h2 class="text-red-500 font-medium pb-2">Takeaway Note:</h2>
        <div
          class="flex items-start gap-2 rounded-md bg-red-50 border border-red-300 text-red-800 text-xs p-3"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 mt-0.5 text-red-500"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.682-1.36 3.447 0l5.516 9.817c.75 1.335-.213 3.084-1.723 3.084H4.464c-1.51 0-2.473-1.75-1.723-3.084l5.516-9.817zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-1-2a.75.75 0 01-.75-.75v-3a.75.75 0 011.5 0v3A.75.75 0 0110 11z"
              clip-rule="evenodd"
            />
          </svg>
          <span>
            Modification is no longer allowed, as the payment process has
            already been initiated.
          </span>
        </div>
      </div>
      <div
        class="flex justify-between items-center"
        v-if="formData.approvaltype === 'Declined'"
      >
        <button
          :disabled="!formData.declinedremarks"
          @click="exportPDF(formData)"
          class="px-3 text-xs py-2 rounded-md transition font-medium bg-red-400 text-white hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-1 disabled:bg-red-200 disabled:cursor-not-allowed"
        >
          Decline Preview
        </button>

        <div class="flex items-center space-x-2">
          <input
            type="checkbox"
            id="doctor-signature"
            name="E-Signature of Doctor"
            v-model="formData.declinedverify"
            class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          />
          <label
            for="doctor-signature"
            class="text-xs text-gray-700 font-medium"
          >
            E-Signature of Doctor
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdfGenerateHandler from "@/utils/reusables/pdfDecline";
import IntegrateMAMs from "@/components/partial/Application/SectionMAMs.vue";
import { ref, watch, inject, computed } from "vue";
export default {
  props: {
    formData: Object,
    errors: Object,
    ifCurrentMode: String,
  },
  components: {
    IntegrateMAMs,
  },
  setup(props) {
    const { exportPDF } = pdfGenerateHandler();
    const axios = inject("$axios");
    const moment = inject("$moment");
    const availmentItems = ref(["In-Patient", "Out-Patient"]);
    const approvaltypeItems = ref([
      "Assessment",
      "Pending Documents",
      "Approved",
      "Declined",
    ]);

    const transactionItems = ref([
      "Consultation",
      "Laboratory",
      "APE",
      "Emergency",
      "Surgical",
    ]);
    const declinedItems = ref([
      "Diagnosis Exclusion",
      "Lapsed",
      "Late Filing of Documents",
      "Non-Cardholder",
      "Over-Age",
      "Pre-Existing Condition",
      "Take home medicines not covered",
      "Others",
    ]);
    const providername = ref(props.formData.providername || "");
    const itemProviders = ref([]);
    const itemCompanies = ref([]);
    const showSuggestions = ref(false);
    const showSuggestionsCompany = ref(false);
    const formUpdate = ref({});
    const isImportApproval = ref(false);
    const fetchDataMAMs = ref([]);

    const filterSuggestions = async () => {
      const search = providername.value.trim();

      try {
        const { data } = await axios.get(
          "https://deped-api.onrender.com/meta/api/iwc/providers",
          { params: { search } }
        );
        itemProviders.value = data;
        showSuggestions.value = true;
      } catch (error) {
        console.error("Error fetching providers:", error);
        itemProviders.value = [];
      }
    };

    const selectProvider = (provider) => {
      providername.value = provider;
      props.formData.providername = provider;
      showSuggestions.value = false;
    };

    watch(providername, (val) => {
      props.formData.providername = val;
    });

    const filterCompanies = async () => {
      try {
        const value = props.formData.company;
        const { data } = await axios.get(
          `https://utilization-report-server.onrender.com/company`,
          {
            params: {
              name: value,
            },
          }
        );
        itemCompanies.value = data;

        showSuggestionsCompany.value = value ? true : false;
      } catch (error) {
        itemCompanies.value = [];
        console.error("Error fetching transactions:", error);
      }
    };
    const selectCompany = (company) => {
      props.formData.company = company;
      showSuggestionsCompany.value = false;
    };
    const filteredCompanies = computed(() =>
      itemCompanies.value.filter(
        (item) => item.Companies !== "No companies found"
      )
    );
    const currentDate = computed(() => {
      return moment().format("YYYY-MM-DD");
    });
    const getDataFromMAMS = (val) => {
      fetchDataMAMs.value = val[0];
      props.formData.approvalno = val[0].approvalno;
      props.formData.company = val[0].company;
      props.formData.membername = val[0].membername;
      props.formData.providername = val[0].providername;
      props.formData.availmenttype = val[0].availmenttype;
      props.formData.transtype = val[0].transtype;
      props.formData.admitdate = val[0].admitdate;
      props.formData.dischargedate = val[0].dischargedate;
      props.formData.symptoms = val[0].symptoms;
      props.formData.reimbursableamount = val[0].coveredamount;
      providername.value = val[0].providername;
    };
    return {
      availmentItems,
      approvaltypeItems,
      formData: props.formData,
      errors: props.errors,
      providername,
      itemProviders,
      showSuggestions,
      filterSuggestions,
      selectProvider,
      transactionItems,
      formUpdate,
      filterCompanies,
      itemCompanies,
      selectCompany,
      showSuggestionsCompany,
      declinedItems,
      filteredCompanies,
      currentDate,
      exportPDF,
      isImportApproval,
      getDataFromMAMS,
      fetchDataMAMs,
    };
  },
};
</script>
